var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import PropTypes from 'prop-types';
import { resolve } from '@cvent/nucleus-dynamic-css';
import { resolveTestId } from '@cvent/nucleus-test-automation';
/**
# TextCounter Component
**/
var TextCounter = function (props) {
    var label = props.label, digit = props.digit;
    return React.createElement("span", __assign({}, resolveTestId(props), resolve(props, 'text')),
        React.createElement("span", __assign({}, resolve(props, 'digit')), digit),
        React.createElement("span", __assign({}, resolve(props, 'label')), label));
};
TextCounter.displayName = 'TextCounter';
TextCounter.propTypes = {
    /** Label text for the counter. */
    label: PropTypes.string,
    /** The actual value to display in the counter. */
    digit: PropTypes.number.isRequired,
    /** Available Style Keys. */
    style: PropTypes.shape({
        /** Top level style applied to the container. */
        text: PropTypes.object,
        /** Style applied to the digit part of the counter. */
        digit: PropTypes.object,
        /** Style applied to the label part of the counter. */
        label: PropTypes.object
    })
};
export default TextCounter;
